import React, {useState} from 'react';
// import './Createcampaign.css';
import MultiStepForm from '../component/MultiStepForm';


  



const CreateCampaign: React.FC = () => {

  return (
    <>
     <MultiStepForm />
    </>
  );
};

export default CreateCampaign;
